import * as React from 'react'

import styles from './karte.module.css'

import InlineSVG from 'svg-inline-react'

import bind from 'bind-decorator'

import { StoreComponent, injectStores } from '../../store'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { ListOverlay } from './listOverlay'
import { Portal } from 'react-portal'

@injectStores
@observer
export class Karte extends StoreComponent {
  elem = React.createRef<HTMLDivElement>()
  @observable expanded = false
  @observable openCountry: string | null = null

  componentDidMount () {
    if (this.elem && this.elem.current) {
      this.elem.current.addEventListener('click', this.handleClick, false)
    }
  }

  @bind
  getNodeByAttribute (target: any, attribute: string, searchDepth = 5): Node | null {
    let i = 0
    while (target && i < searchDepth) {
      if (target && target.hasAttribute && target.hasAttribute(attribute)) {
        return target
      } else {
        target = target.parentNode
        i += 1
      }
    }
    return null
  }

  @bind
  handleClick (e: any) {
    const plus = this.getNodeByAttribute(e.target, 'data-name')
    if (plus && (plus.nextSibling || plus.previousSibling)) {
      const nextSibling = plus.nextSibling as Element
      const prevSibling = plus.previousSibling as Element
      const country = nextSibling ? nextSibling.getAttribute('data-name') : prevSibling.getAttribute('data-name')
      if (country && country !== 'Plus') {
        this.expanded = true
        this.openCountry = country
      }
    }
  }

  @bind
  closeOverlay () {
    this.expanded = false
  }

  render () {
    let overlay: JSX.Element | null = null
    if (this.expanded) {
      overlay = <Portal><ListOverlay country={this.openCountry} onCloseClick={this.closeOverlay}/></Portal>
    }

    return (
      <div className={styles.mapContainer} ref={this.elem}>
       <InlineSVG src={require('../../svgs/weltweit.inline.svg')}/>
       {overlay}
      </div>
    )
  }
}
